import { useTranslation } from 'react-i18next';
import { Redirect, useRouteMatch } from 'react-router-dom';
import { NS } from '../../../models/I18n';
import Link from '../../../shared/components/links/Link';
import { useSubmissionResultQuery, useUserInfoQuery } from '../../SubmissionAPI';
import { SuperVisasSideBar } from '../components/CrsSection';

export function HubSpot() {
  const { t } = useTranslation(NS.Eligibility);
  const match = useRouteMatch<{ submissionId: string }>('/eligibility/:submissionId/book_a_time');
  const submissionId = match?.params.submissionId || '';
  const { data: userInfoResult } = useUserInfoQuery();
  const { isLoading, data: submissionResult } = useSubmissionResultQuery(submissionId);
  if (isLoading || !submissionResult || !userInfoResult) {
    return null;
  }
  const {
    lead,
    user,
    submission: { country },
  } = submissionResult;
  const loggedInUser = userInfoResult.user_info;
  if (!lead && !user && !loggedInUser) {
    return <Redirect to={`/eligibility/${submissionId}/contact_info`} />;
  }
  const firstName = (lead || user || loggedInUser)?.first_name || '';
  const lastName = (lead || user || loggedInUser)?.last_name || '';
  const email = (lead || user || loggedInUser)?.email || '';
  return (
    <div className="block lg:flex">
      <SuperVisasSideBar />
      <div className="w-full bg-white px-8 py-3 lg:min-h-screen lg:w-3/4 lg:pr-24">
        <div className="mb-2 text-base font-semibold text-gray-600 lg:text-2xl">{t('leadActions.schedule-a-call')}</div>
        <div className="mb-3 text-base text-gray-600">{t('leadInfoView.ready-to-assist')}</div>
        <div className="max-w-[850px]">
          <iframe
            className="h-[670px] w-full"
            src={`https://meetings.hubspot.com/joe-chen/${
              country === 'CA' ? 'consultation' : 'consultation-united-states'
            }?embed=true&firstname=${firstName}&lastname=${lastName}&email=${email}`}
            title="HubSpot"
          />
          <div className="mt-4 flex justify-end gap-4">
            <Link variant="secondary" to={`/eligibility/${submissionId}/result`}>
              {t('leadInfoView.back')}
            </Link>
            {!user && !loggedInUser && (
              <Link variant="primary" to={`/eligibility/${submissionId}/sign_up`}>
                {t('leadInfoView.next')}
              </Link>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
